import type { WorkspaceFile } from '@/types/workspace';
import { createNamedContext } from '@trinity/chat-components';

export type FileActionsContextValue = {
  changeOwner: () => unknown;
  delete: () => unknown;
  download: () => Promise<unknown>;
  downloadTranscript: () => unknown;
  manageAccess: () => unknown;
  move: () => unknown;
  rename: () => unknown;
  viewFile: () => unknown;
};

export type FileMenuItemsContextValue = {
  canChangeOwner: boolean;
  canDelete: boolean;
  canDownload: boolean;
  canManageAccess: boolean;
  canMove: boolean;
  canRename: boolean;
  canTranscribe: boolean;
  canImportTranscript: boolean;
  canViewTranscript: boolean;
};

export type RenameFileContextValue = {
  file: WorkspaceFile;
  rename: (name: string) => Promise<unknown>;
};
type DownloadFile = () => Promise<unknown>;
type DeleteFile = () => Promise<unknown>;
type TranscribeFile = () => Promise<unknown>;
type ImportTranscript = () => Promise<unknown>;
type ViewFileTranscript = () => unknown;

export const DeleteFileContext = createNamedContext<DeleteFile>(undefined, 'delete-file');
export const FileActionsContext = createNamedContext<FileActionsContextValue>(undefined, 'file-actions');
export const FileMenuItemsContext = createNamedContext<FileMenuItemsContextValue>(undefined, 'file-menu-items');
export const DownloadFileContext = createNamedContext<DownloadFile>(undefined, 'download-file');
export const TranscribeFileContext = createNamedContext<TranscribeFile>(undefined, 'transcribe-file');
export const ImportTranscriptContext = createNamedContext<ImportTranscript>(undefined, 'import-transcript');
export const ViewFileTranscriptContext = createNamedContext<ViewFileTranscript>(undefined, 'view-file-transcript');